<template>
    <NuxtLayout>
        <div class="min-h-screen flex flex-col justify-between">
            <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
                <div class="text-center">
                    <p class="text-base font-semibold text-primary-600">
                        {{ error?.statusCode }}
                    </p>
                    <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                        {{ error?.message }}
                    </h1>
                    <div class="mt-10 flex items-center justify-center gap-x-6">
                        <NuxtLink
                            :to="isAuthenticated ? { name: 'dashboard' } : { name: 'auth'}"
                            class="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-primary-500 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
                            Go back home
                        </NuxtLink>
                    </div>
                </div>
            </main>
        </div>
    </NuxtLayout>
</template>

<script setup>
import { useAuthStore } from '@/store/auth'

const error = useError()
const {isAuthenticated} = toRefs(useAuthStore())

useHead({
    bodyAttrs: {
        class: 'h-full'
    },
    htmlAttrs: {
        class: 'h-full'
    },
})



</script>